const Footer = () => {
  return (
    <footer className="footer bg-violet-700 text-violet-50 text-center py-10">
      &copy; {new Date().getFullYear()} Tech Zone. All Rights Reserved
    </footer>
  );
};

export default Footer;
